import React, { useEffect, useState, lazy, Suspense, useMemo } from "react";
import axios from "axios";
import { getStoredData } from "../../json/fetchData";
import { useNavigate } from "react-router-dom";
import "./AdminActivities.css";

// Lazy load ProductList component
const ProductList = lazy(() =>
  import("../../components/DynamicListGrid/DynamicListGrid")
);

const AdminActivities = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // ✅ Corrected: Call the function to get stored data
  const config = useMemo(() => {
    const data = getStoredData(); // ← Call the function
    return data?.["19"];
  }, []);

  const fields = config?.AdminActivities || [];
  const apiUrl = config?.AdminActivitiesApi;
  const redirectPath = config?.AdminProjectsEdit;
  console.log(apiUrl);

  useEffect(() => {
    if (!apiUrl) {
      setError("API configuration not found.");
      setLoading(false);
      return;
    }

    const fetchProducts = async () => {
      try {
        const response = await axios.get(apiUrl);
        setProducts(response.data);
      } catch (err) {
        console.error("Error fetching activities:", err);
        setError("Failed to fetch activities. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [apiUrl]);

  if (loading) return <p className="loading-message">Loading activities...</p>;
  if (error) return <p className="error-message">{error}</p>;

  return (
    <div className="admin-products">
      <Suspense fallback={<p>Loading component...</p>}>
        <ProductList
          products={products}
          fields={fields}
          redirect={redirectPath}
          deleteApi={apiUrl}
          RedirectNew="/admin/add-activities"
          HeaderTitle="Activities List"
        />
      </Suspense>
    </div>
  );
};

export default AdminActivities;
